.dropdown_select {
    min-width: 300px;
    background: var(--axl-elevated);

    :global {

        .ant-dropdown-menu,
        .ant-dropdown-menu-item {
            cursor: default !important;

            margin: 0 !important;
            padding: 0 !important;

            background-color: unset !important;
            box-shadow: none !important;
        }

        .accel_select__menu {
            position: relative;
            margin-bottom: 0 !important;
        }
    }
}

.transparent {
    background: transparent !important;

    :global {

        .ant-dropdown-menu,
        .ant-dropdown-menu-item {
            background: transparent;

            &:hover {
                background: transparent;
            }
        }
    }
}
